import "./notFound.css"

export const NotFound = () => {
  return (
    <div className="notFound">
      <img src="https://freefrontend.com/assets/img/html-css-404-page-templates/HTML-404-Page-Animated.png" alt="" />
    </div>
  )
}
